module.exports = __webpack_public_path__ + "static/img/avatar.014e81be.png";